import { createAction } from '@reduxjs/toolkit';
import { PaginationParams } from '../../types/apiType';

export const ImageActions = {
  getList: createAction<{ pagination: PaginationParams } | undefined>('image/GET_LIST'),
};
